const url = "/api/v1/user_ui";

export interface UserUiUpdateParams {
  hasClosedOnboardingMessage?: true;
  hasClosedReferralMessage?: true;
  hasClosedTrialOneWeekLeft?: true;
  hasClosedTrialThreeWeeksLeft?: true;
}

export const userUiUpdateQuery = (params: UserUiUpdateParams) => ({
  url,
  method: "PATCH",
  body: params,
});
